import React, { Component } from 'react'

import cn from 'classnames'
import s from './Crumbs.scss'
import sLay from 'styles/modules/layout.scss'

export default class Crumbs extends Component {
  render() {
    const { children, title, dark, className, ...otherProps } = this.props
    return (
      <div
        className={cn(
          sLay['layout-row'],
          sLay['layout-align-gt-xs-start-center'],
          s.crumbs,
          { [s.dark]: dark },
          className
        )}
        {...otherProps}
      >
        {title && <span className={s.title}>{title}</span>}
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/BreadCrumbs/Crumbs.jsx